import React, { useRef, useState } from 'react';
import { ErrorMessage } from 'formik';
import styled from 'styled-components';

import Eye from '../../Images/Eye';
import EyeClose from '../../Images/EyeClose';

const PasswordEye = styled(Eye)`
  position: absolute;
  right: 9px;
  top: 26px;
`;
const PasswordClose = styled(EyeClose)`
  position: absolute;
  right: 9px;
  top: 26px;
`;
const InputLabel = styled.label`
  margin-right: 6px;
`;

const InputLabelDiv = styled.div`
  display: flex;
  align-items: center;
`;

const InputDiv = styled.div`
  background-color: #f3f3f5;
  border-radius: 4px;
  // margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  position: relative;
  border: ${({ error }) => (error ? 'solid 1px var(--Punch500)' : 'none')};

  textarea,
  input {
    width: 100%;
    height: ${({ isLarge, isTextArea, height }) =>
      height ? height : isTextArea ? 'unset' : isLarge ? '68px' : '56px'};
    padding: ${({ isTextArea, padding }) =>
      padding ? padding : isTextArea ? '20px 16px 0 10px' : '14px 16px 0 10px'};
    // padding: 14px 16px 0 10px;
    outline: 0;
    border: none;
    border-radius: 4px;
    font-size: ${({ fontSize }) => fontSize || '16px'};
    line-height: 1.5;
    text-align: left;
    color: var(--Text700);
  }

  ${InputLabelDiv} {
    font-size: ${({ isLarge, height }) =>
      isLarge ? (height === '48px' ? '12px' : '14px') : '12px'};
    line-height: 1.33;
    text-align: left;
    color: var(--Text300);
    padding: 0 12px;
    // pointer-events: none;
    position: absolute;
    transform: ${({ isTextArea, active, isLarge, height }) =>
      active && isTextArea
        ? 'translate(0, 6px) scale(0.75)'
        : isTextArea
          ? 'translate(0, 20px) scale(1)'
          : active
            ? height === '48px'
              ? 'translate(0, 3px) scale(0.75)'
              : 'translate(0, 12px) scale(0.75)'
            : isLarge
              ? height === '48px'
                ? 'translate(0, 18px) scale(1)'
                : 'translate(0, 25px) scale(1)'
              : 'translate(0, 22px) scale(1)'};
    transform-origin: top left;
    transition: all 0.2s ease-out;
  }
  &:focus-within ${InputLabelDiv} {
    transform: ${({ isTextArea, height }) =>
      isTextArea
        ? 'translate(0, 6px) scale(0.75)'
        : height === '48px'
          ? 'translate(0, 3px) scale(0.75)'
          : 'translate(0, 12px) scale(0.75)'};
  }
`;
const Input = styled.input`
  background-color: #f3f3f5;
  cursor: ${({ disabled, readOnly }) =>
    disabled || readOnly ? 'not-allowed' : 'auto'};
`;

const FloatingInput = ({
  hasError,
  label,
  infoTitle,
  height,
  padding,
  fontSize,
  asTextArea,
  rowCount,
  onChange,
  size = 'lg',
  password,
  showValidation,
  touched,
  autoFocus,
  isMandatory,
  ...props
}) => {
  const [isInputActive, setIsInputActive] = useState(!!props.value); // this is needed for floating placeholder
  const inputRef = useRef();
  const [togglePassword, setTogglePassword] = useState(false);
  const handleInputChange = (text) => {
    if (text !== '') {
      setIsInputActive(true);
    } else {
      setIsInputActive(false);
    }
    onChange(text);
  };

  const handleDivClick = () => {
    if (inputRef && inputRef.current) {
      inputRef.current.focus();
    }
  };
  const showPassword = (id) => {
    setTogglePassword(!togglePassword);
    const x = document.getElementById(id);
    if (x.type === 'password') {
      x.type = 'text';
    } else {
      x.type = 'password';
    }
  };

  return (
    <>
      <InputDiv
        height={height}
        padding={padding}
        fontSize={fontSize}
        isTextArea={asTextArea}
        active={isInputActive}
        error={touched && hasError}
        isLarge={size === 'lg'}
        onClick={handleDivClick}
      >
        <Input
          autoFocus={autoFocus}
          type="text"
          ref={inputRef}
          onChange={(e) => handleInputChange(e.target.value)}
          {...(asTextArea && { as: 'textarea', rows: rowCount || 5 })}
          {...props}
          id={password && `${label}password`}
        />
        {password && !togglePassword && (
          <PasswordEye onClick={() => showPassword(`${label}password`)} />
        )}
        {password && togglePassword && (
          <PasswordClose onClick={() => showPassword(`${label}password`)} />
        )}
        <InputLabelDiv isTextArea={asTextArea}>
          <InputLabel htmlFor={props.name}>
            {label || 'Enter Detail'}
            {isMandatory && <span className="asterisk-sign">*</span>}
          </InputLabel>
          {/* {infoTitle && <InfoIcon title={infoTitle}/>} */}
        </InputLabelDiv>
      </InputDiv>
      {showValidation && (
        <ErrorMessage
          component="div"
          name={props.name}
          style={{ color: 'red' }}
        />
      )}
    </>
  );
};
export default FloatingInput;
